export default "__VITE_ASSET__DSrVEBaB__"